import React from 'react';
import PropTypes from 'prop-types';
import { CoreForm } from 'components/core/library/form';

import './form.scss';

export default function Form(props) {
	return (
		<CoreForm {...props} />
	);
}

Form.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	failureLabel: PropTypes.string,
	invalid: PropTypes.bool,
	onSubmit: PropTypes.func,
	successLabel: PropTypes.string,
	id: PropTypes.string
};
